var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, Column, Div } from "react-vcomponents";
import { AddGlobalStyle, BaseComponent } from "react-vextensions";
import { ScrollView } from "react-vscrollview";
import { NotificationMessage } from "Store/main";
import { store } from "Store";
import { Observer } from "vwebapp-framework";
import { runInAction } from "mobx";
// helper, for use from Start_0.ts
function AddNotificationMessage(message) {
    store.main.notificationMessages.push(new NotificationMessage(message));
}
G({ AddNotificationMessage });
AddGlobalStyle(`
.NotificationScrollView > * { pointer-events: auto; }
.NotificationScrollView { pointer-events: none; }
.NotificationScrollView > .content > * { pointer-events: auto; }
.NotificationScrollView > .content { pointer-events: none; }
`);
let NotificationsUI = class NotificationsUI extends BaseComponent {
    render() {
        const messages = store.main.notificationMessages;
        return (React.createElement(ScrollView, { ref: c => this.scrollView = c, className: "NotificationScrollView", scrollVBarStyle: { width: 10 }, contentStyle: { willChange: "transform" } },
            React.createElement(Column, { ct: true, style: { maxWidth: "calc(100% - 10px)", alignItems: "flex-start", filter: "drop-shadow(0px 0px 10px rgba(0,0,0,1))" } }, messages.map((message, index) => {
                return React.createElement(MessageUI, { key: index, message: message });
            }))));
    }
    PostRender() {
        this.scrollView.UpdateSize();
    }
};
NotificationsUI = __decorate([
    Observer
], NotificationsUI);
export { NotificationsUI };
/* export class MessageUI extends BaseComponent<{message: NotificationMessage}, {}> {
    render() {
        let {message} = this.props;
        return (
            <Row style={{background: "rgba(255,255,255,.3)", borderRadius: 5}}>
                <Span ml={7} mt={5} mb={5} sel>{message.text}</Span>
                <Button text="X" ml={5} style={{padding: "2px 4px"}} onClick={()=> {
                    store.dispatch(new ACTNotificationMessageRemove(message.id));
                }}/>
            </Row>
        );
    }
} */
export class MessageUI extends BaseComponent {
    render() {
        const { message } = this.props;
        const backgroundColor = "40,60,80";
        return (React.createElement(Div, { ml: 10, mt: 10, style: { position: "relative", borderRadius: 5, cursor: "default", boxShadow: "rgba(0,0,0,1) 0px 0px 2px" } },
            React.createElement("div", { style: { display: "flex", background: "rgba(0,0,0,.7)", borderRadius: 5 /* cursor: "pointer" */ } },
                React.createElement("div", { style: { position: "relative", padding: 5 } },
                    React.createElement("div", { style: {
                            position: "absolute", left: 0, right: 0, top: 0, bottom: 0,
                            background: `rgba(${backgroundColor},.7)`, borderRadius: "5px 0 0 5px",
                        } }),
                    React.createElement(Div, { sel: true, style: { position: "relative", fontSize: 14, whiteSpace: "pre-wrap", wordBreak: "break-word" } }, message.text)),
                React.createElement(Button // text={expanded ? "-" : "+"} size={28}
                , { style: {
                        display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "0 5px 5px 0",
                        width: 18, padding: "2px 4px", fontSize: 13, lineHeight: "1px",
                        backgroundColor: `rgba(${backgroundColor.split(",").map(a => (parseInt(a) * 0.8).RoundTo(1)).join(",")},.7)`,
                        // boxShadow: "none",
                        border: "none",
                        ":hover": { backgroundColor: `rgba(${backgroundColor.split(",").map(a => (parseInt(a) * 0.9).RoundTo(1)).join(",")},.7)` },
                    }, onClick: e => {
                        runInAction("MessageUI.RemoveMessage.onClick", () => store.main.notificationMessages.Remove(message));
                    } }, "X"))));
    }
}
